/* KYŌ KOHEE — theme.js */

// Scroll-triggered fade-in
(function () {
  'use strict';

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.fade-in-section').forEach(function (el) {
    observer.observe(el);
  });
})();

// Dropdown nav accessibility
(function () {
  document.querySelectorAll('.nav-link--dropdown').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        this.setAttribute('aria-expanded', 'false');
        this.focus();
      }
    });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-dropdown')) {
      document.querySelectorAll('.nav-link--dropdown').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();

// Quantity input helpers (used by product page)
(function () {
  document.querySelectorAll('.product-page__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input  = this.closest('.product-page__qty-wrap').querySelector('.product-page__qty-input');
      var val    = parseInt(input.value, 10) || 1;
      var isPlus = this.textContent.trim() === '+';
      input.value = isPlus ? val + 1 : Math.max(1, val - 1);
    });
  });
})();
